import React from "react";
import {Form, Input, Button, Modal, Col, Row, notification} from 'antd';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { authLogin } from "../store/actions/auth";
import {
UserOutlined, LockOutlined, CloseCircleOutlined
} from '@ant-design/icons';
import {forgotPasswordURL} from "../constants";
import axios from "axios";

const validateMessages = {
  required: 'Vui lòng nhập ${label} !',
  types: {
      email: '${label} không đúng định dạng email!',
      number: '${label} không phải số!',
  },
  number: {
      range: '${label} must be between ${min} and ${max}',
  },
};

const messageBox = (type, title, contents) => {
	notification[type]({
	  message: title,
	  description:
	  	contents,
	});
};

class LoginForm extends React.Component {
  state = {
    username: "",
    password: "",
    loadings: false,
    modalVisibleRestPass: false,
  };

  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  handleModalForgotPass = () => {
    // messageBox('warning', 'Thông báo', 'Chức năng đang phát triển')
    this.setState({
      modalVisibleRestPass: true,
    });
  };

  fetchApiForgotPass = (params = {}) => {
    this.setState({ loading: true });
    var FormData = require('form-data');
    var data = new FormData();
    data.append('inputEmail', params.email)
    axios
      .post(forgotPasswordURL, data)
      .then(res => {
          if (res.data.error) {
              const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
              messageBox('error', 'Lỗi', dataError)
              this.setState({modalVisibleRestPass:false})
          }
          else {
              messageBox('success', 'Thông báo', 'Đặt lại mật khẩu thành công. Vui lòng kiểm tra hộp thư')
              this.setState({modalVisibleRestPass:true})
              // this.logout_new()
          }
          this.setState({loading:false})
      })
      .catch(err => {
          messageBox('error', 'Lỗi', "Địa chỉ email sai. Vui lòng kiểm tra lại!")
      });
    }

  onFinishForgotPass = (values) => {
    this.setState({loading:true})

    this.fetchApiForgotPass({
      email: values.email
    })
  };

  handleModalCancel = () => {
    this.setState({ modalVisibleRestPass: false });
  };

  ForgotPass = (modalVisibleRestPass) => {
    return (
      <Modal
          destroyOnClose
          title="Đặt lại mật khẩu"
          visible={modalVisibleRestPass}
          onCancel={ this.handleModalCancel }
          footer={null}
          closeIcon={ <CloseCircleOutlined title="Thoát (ESC)"/> }
          keyboard // press esc to close
          style={{width: '500px', "top":'250px'}}
        >
        <Form
            onFinish={(values) => this.onFinishForgotPass(values)} validateMessages={validateMessages}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
        >
          <Col sm={24} offset={0}>
              <Form.Item name='email'
                  rules={[{
                          required: true,
                          type: 'email'
                        },]}
                  label={"Email đã đăng ký"}
              >
                  <Input/>
              </Form.Item>
          </Col>
          <Row style={{  paddingBottom: '10px' }}>
          <Col span={24} style={{textAlign:"center"}}>
            <Button shape="round" size="default" type="primary" htmlType="submit">Đặt lại mật khẩu </Button>
          </Col>
          </Row>
        </Form>
      </Modal>
    )
  };

  render() {
    const { error, loading, token } = this.props;
    if (token) {
      localStorage.setItem("currentSelectedKeys", JSON.stringify(['1']))
      return (
          (<Redirect to="/" />))
    }
    const { loadings } = this.state;
    const onFinish = (values) => {
      this.props.login(values.username, values.password);
    };
    const error_sv = localStorage.getItem('error_s')
    if (error_sv) {
      localStorage.removeItem('error_s');
    }
    return (<>
      {this.ForgotPass(this.state.modalVisibleRestPass)}

          <Form
      name="normal_login"
      className="login-form"
      initialValues={{
        username:'',
        password:'',
        remember: true,
      }}
      onFinish={onFinish}
    >
    {error && ('error' in error.response.data ? <p>{error.response.data.error}</p> : <p>{this.props.error.message}</p>)}
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'Vui lòng nhập tên đăng nhập!',
          },
        ]}
      >
        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Tên đăng nhập" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Vui lòng nhập mật khẩu!',
          },
        ]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="Mật khẩu"
        />
      </Form.Item>
      <Form.Item>
        {/* <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox>Ghi nhớ đăng nhập</Checkbox>
        </Form.Item> */}
        <span onClick={ this.handleModalForgotPass } className="login-form-forgot" style={ {cursor: "pointer", color:"#1890ff"}}>Quên mật khẩu ?</span>
        {/* <a className="login-form-forgot" href="/">
          Quên mật khẩu
        </a> */}
      </Form.Item>

      <Form.Item>

        <Button type="danger" htmlType="submit" className="login-form-button" loading={loading} onClick={() => loadings}>
          Đăng nhập
        </Button>
        {/*Hoặc <a href="/">đăng ký tại đây!</a>*/}
      </Form.Item>
    </Form>
    </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => dispatch(authLogin(username, password))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);
